import React, { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  colors,
} from "@mui/material";
import Tab4DailyEnergy from "./tab4DailyEnergy/Tab4DailyEnergy";
import PlantEnergyData from "../plantEnergy/PlantEnergyData";

export default function Tab4MonthlyEnergyTabs() {
  const [selectedTab, setSelectedTab] = useState("Solar Energy Generation");
  const handleChange = (event) => {
    setSelectedTab(event.target.value);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div style={containerStyle}>
            <div style={responsiveControlsStyle}>
              <FormControl component="fieldset">
                <RadioGroup row value={selectedTab} onChange={handleChange}>
                  <FormControlLabel
                    value="Solar Energy Generation"
                    control={<Radio size="small" />}
                    label={
                      <Typography sx={{ color: "black !important" }}>
                        Solar Energy Generation
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="Inverter Wise Status"
                    control={<Radio size="small" />}
                    label={
                      <Typography sx={{ color: "black !important" }}>
                        Inverter Wise Status
                      </Typography>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          {/* Content based on selected tab */}
          <div style={{ marginTop: "20px" }}>
            {selectedTab === "Solar Energy Generation" && <PlantEnergyData />}
            {selectedTab === "Inverter Wise Status" && <Tab4DailyEnergy />}
          </div>
        </div>
      </div>
    </>
  );
}

// Style definitions
const containerStyle = {
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  height: "35px",
  border: "1px solid #25476A",
  
  padding: "0",
  borderRadius: "7px",
  marginBottom: "10px",
};

const responsiveControlsStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  paddingLeft: "10px",
  
};




// import React, { useState } from "react";
// import {
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   Box
// } from "@mui/material";
// import Tab4DailyEnergy from "./tab4DailyEnergy/Tab4DailyEnergy";
// import Tab4YearlyEnergy from "./tab4YearlyEnergy/Tab4YearlyEnergy";
// import InverterFullSizeDailyEnergy from "./InverterFullSizeDailyEnergy";
// import PlantEnergy from "../plantEnergy/PlantEnergy";
// import PlantEnergyData from "../plantEnergy/PlantEnergyData";

// export default function Tab4MonthlyEnergyTabs({ onFullScreen }) {
//   const [selectedTab, setSelectedTab] = useState("Solar Energy Generation");

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   const radioTitle = (
//     <RadioGroup
//       row
//       value={selectedTab}
//       onChange={handleChange}
//       sx={{
//         backgroundColor: "black", // Background of the whole radio group
//         padding: "8px",
//         borderRadius: "4px"
//       }}
//     >
//       <FormControlLabel
//         value="Solar Energy Generation"
//         label="Solar Energy Generation"
//         control={<Radio size="small" sx={{ color: "white", '&.Mui-checked': { color: "white" } }} />}
//         sx={{ color: "white" }}
//       />
//       <FormControlLabel
//         value="Inverter Wise Status"
//         label="Inverter Wise Status"
//         control={<Radio size="small" sx={{ color: "white", '&.Mui-checked': { color: "white" } }} />}
//         sx={{ color: "white" }}
//       />
//     </RadioGroup>
//   );

//   return (
//     <InverterFullSizeDailyEnergy title={radioTitle} onFullScreen={onFullScreen}>
//       {/* Tab Content */}
//       <Box sx={{ marginTop: "10px" }}>
//         {selectedTab === "Solar Energy Generation" && <PlantEnergyData />}
//         {selectedTab === "Inverter Wise Status" && <Tab4DailyEnergy />}
//       </Box>
//     </InverterFullSizeDailyEnergy>
//   );
// }

